import script from "./WalletTransactionsQuery.vue?vue&type=script&lang=js"
export * from "./WalletTransactionsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__